export { default, TARIFFS_OPTIONS_POPUP_NAME, type TariffsOptionsPopupProps } from './TariffsOptionsPopup';
